import { createMuiStyles } from '../../../../utils/mui';

export const featuredScholarshipsStyles = createMuiStyles({
  sliderContainer: {
    '.featuredScholarshipsSlider': {
      px: 'var(--container-fluid-padding)',
    },
    '.swiper-slide': {
      height: 'auto',
    },
  },
  findMoreBtn: {
    bgcolor: 'common.white',
    '&:hover, &:focus, &:active': {
      bgcolor: 'primary.light',
    },
  },
});
